<template>
  <div class="home">
    <hearder :isHome="true"> </hearder>
    <el-container>
      <el-container>
        <el-aside width="240px">
          <div id="leftIndexMenu" class="menu">
            <div
              style="box-shadow:inset 0px 8px 7px 0px rgba(16,88,246,0.2);height:14px;width: 240px;display: inline-block;
           "
            ></div>
            <ul class="menu-ul">
              <li class="menu-item-document">
                <div class="menu-item-content" @click="toggle">
                  <span class="iconfont toggle-icon" v-if="!showDocument"
                    >&#xe614;</span
                  >
                  <span class=" iconfont ">&#xe611;</span>
                  <span class="ml5">我的文集</span>
                  <span class="iconfont fr mr20" @click.stop="addDocument"
                    >&#xe74a;</span
                  >
                </div>
              </li>
              <li class="menu-item-document" v-show="showDocument">
                <div
                  class="menu-item-content ml16"
                  @click="todocument('/document', 0)"
                  :class="{
                    menuItemActive:
                      activeMenu === '/document' || activeMenu === '/'
                  }"
                >
                  <span class="iconfont">&#xe75f;</span>
                  <span class="ml5">默认文集</span>
                </div>
              </li>
              <li
                class="menu-item-document"
                v-show="showDocument"
                v-for="item in folder"
                :key="item.folderId"
              >
                <div
                  class="menu-item-content ml16"
                  @click="todocument('/document/' + item.name, item.folderId)"
                  :class="{
                    menuItemActive: activeMenu === '/document/' + item.name
                  }"
                >
                  <span class="iconfont">&#xe75f;</span>
                  <span class="ml5">{{ item.name }}</span>
                  <span
                    class="iconfont fr mr20 folderdelete"
                    :class="{
                      isdelete:
                        isShowDeleteFolder && item.folderId === deleteFolderId
                    }"
                    @click.stop="deleteFolderDialog(item.folderId)"
                    >&#xe632;</span
                  >
                </div>
              </li>
              <Div
                style="border-top: 1px solid #eeeeee; margin-left: 20px;margin-right: 20px;margin-top: 10px;"
              ></Div>
              <li class="menu-item">
                <div
                  class="menu-item-content"
                  @click="to('/materialcollection')"
                  :class="{
                    menuItemActive: activeMenu === '/materialcollection'
                  }"
                >
                  <span class="iconfont">&#xe61f;</span>
                  <span class="ml5">素材收藏</span>
                </div>
              </li>
              <Div
                style="border-top: 1px solid #eeeeee; margin-left: 20px;margin-right: 20px;"
              ></Div>
              <li class="menu-item">
                <div
                  class="menu-item-content"
                  :class="{ menuItemActive: activeMenu === '/recycle' }"
                  @click="to('/recycle')"
                >
                  <span class="iconfont">&#xe6ca;</span>
                  <span class="ml5">回收站</span>
                </div>
              </li>
            </ul>
          </div>
        </el-aside>
        <el-main>
          <router-view :folder="folder"></router-view>
        </el-main>
      </el-container>
        <el-footer style="background:#f5f8ff;height:60px;position: fixed;
    bottom: 0;width:100%;z-index: 1000;">
         <div style="text-align: center;color:black!important;font-size: 14px;" v-if='dataSource && dataSource.length>0'>
<div class="links" >
      友情链接：
      <a v-for='(item,index) in dataSource' :key="index" :href="item.url" target="_blank" class="link-item">{{item.title}}</a>
    </div>

        </div>
          <div style="text-align: center;color:black!important;font-size: 14px;margin-bottom:10px;"><a style="color:black!important" target="_blank" href="https://beian.miit.gov.cn/ ">粤ICP备15002054号</a>  珠海市五一一八科技有限公司 </div>
      </el-footer>
    </el-container>

    <!-- 添加文档 -->
    <div class="document-new-dialog" v-if="isShowNew">
      <el-dialog
        :visible.sync="isShowNew"
        top="30vh"
        :center="false"
        width="360px"
        style="border-radius:15px;"
        :close-on-click-modal="false"
      >
        <div slot="title" class="dialog-title ml5 left">新建文集</div>
        <div class="new-document">
          <el-input
            class="documentName"
            v-model="documentName"
            placeholder="请输入文集名称(最多8个文字)"
            size="small "
            @keyup.enter.native="newDocument"
          ></el-input>
        </div>
        <div slot="footer" class="dialog-footer ml5 center">
          <el-button size="mini" class="dialog-newDocument" @click="newDocument"
            >确认</el-button
          >
          <el-button
            size="mini"
            class="dialog-newDocument-cancle"
            @click="cancelNewDocument"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 删除文集弹窗 -->
    <div class="dialog-delete-folder" v-if="isShowDeleteFolder">
      <el-dialog
        :visible.sync="isShowDeleteFolder"
        top="30vh"
        :center="false"
        width="360px"
        style="border-radius:15px"
      >
        <div slot="title" class="dialog-title ml5 left">提示信息</div>
        <div class="">
          <p class="confirm-delete-title">确定删除文集？</p>
          <p class="confirm-delete-info">
            删除文集后里面的文章都被移到回收站中
          </p>
        </div>
        <div slot="footer" class="dialog-footer ml5 center">
          <el-button size="mini" class="dialog-delete" @click="deleteFolder"
            >确认删除</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 登录提示 -->
    <div class="document-dialog" v-if="isShowLogin">
      <el-dialog
        :visible.sync="isShowLogin"
        top="30vh"
        :center="false"
        width="360px"
        style="border-radius:15px"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div slot="title" class="dialog-title ml5 left">账号登录</div>
        <div class="login-tip">您当前暂未登录账号，请先登录账号!</div>
        <div slot="footer" class="dialog-footer ml5 center">
          <el-button size="mini" class="dialog-tologin" @click="tologin"
            >去登陆</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import hearder from "../components/share/Header";
import { mapState, mapActions, mapMutations } from "vuex";
import config from "../assets/script/config/index.js";
// import Cookies from "js-cookie";
export default {
  name: "Home",
  data() {
    return {
      isShowLogin: false,
      isShowNew: false, //新增弹窗
      documentName: "",
      isShowDeleteFolder: false, //删除文件夹
      deleteFolderId: 0,
      showDocument: true,
      activeMenu: "/materialcollection",
      dataSource:[]
      // folder: [],
    };
  },
  components: { hearder },
  computed: {
    ...mapState("home", ["folder"]),
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    contentWidth: {
      get() {
        return this.$store.state.contents.contentWidth;
      },
      set(val) {
        this.$store.state.contents.contentWidth = val;
      }
    }
  },
  methods: {
    ...mapActions("api", ["AFolderCreate", "AFolderDel", "AFolder","AGetFriendship"]),
    ...mapMutations("home", [
      "AAddfolder",
      "setfolder",
      "setFolderId",
      "setBackUrl"
    ]),
    // handleOpen(key, keyPath) {
    //   console.log(key, keyPath);
    // },
    // handleClose(key, keyPath) {
    //   console.log(key, keyPath);
    // },

    addDocument() {
      this.isShowNew = true;
    },
    deleteFolderDialog(deleteFolderId) {
      this.deleteFolderId = deleteFolderId;
      this.isShowDeleteFolder = true;
    },
    selectMenu(activeMenu) {
      this.activeMenu = activeMenu;
    },
    // 跳转
    todocument(url, id) {
      this.activeMenu = url;
      this.$router.push(url);
      this.setFolderId(id);
      this.setBackUrl(url);
    },
    to(url) {
      this.showDocument = false;
      this.activeMenu = url;
      this.$router.push(url);
      this.setBackUrl(url);
    },
    toggle() {
      this.showDocument = !this.showDocument;
      this.todocument("/document", 0);
    },
    // async getFolder() {
    //   var result = await this.AFolder({ pageSize: 0 });
    //   this.folder = result.data.dataSource;
    // },
    cancelNewDocument() {
      this.isShowNew = false;
      this.documentName = "";
    },
    //新增文档
    async newDocument() {
      this.isShowNew = false;
      if (this.documentName.length > 8) {
        this.$message({
          showClose: true,
          message: "最多能输入8个文字",
          type: "error"
        });
        return;
      }
      var result = await this.AFolderCreate({ name: this.documentName });

      if (result.errorCode === 0) {
        await this.AAddfolder({
          folderId: result.data,
          name: this.documentName
        });
        this.documentName = "";
        this.$message({
          message: "新增文档成功",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          showClose: true,
          message: "新增文档失败了",
          type: "error"
        });
      }
    },
    async deleteFolder() {
      var result = await this.AFolderDel({ folderId: this.deleteFolderId });
      if (result.errorCode === 0) {
        var folderResult = this.folder;
        folderResult = folderResult.filter(
          m => m.folderId !== this.deleteFolderId
        );
        this.setfolder({ dataSource: folderResult });
        this.$message({
          message: "删除文档成功",
          type: "success",
          showClose: true
        });
        this.todocument("/document", 0);
        this.isShowDeleteFolder = false;
      } else {
        this.$message({
          showClose: true,
          message: "删除文档失败了",
          type: "error"
        });
      }
    },
    tologin() {
      window.location.href = config.loginUrl;
    }
  },
  async mounted() {
    // let user = Cookies.get("5ceinfo");
    // if (!user || !JSON.parse(user).token) {
    //   this.isShowLogin = false;
    // }
    // this.fixHeight(document.documentElement.clientHeight);
   var result=await this.AGetFriendship();
           if(result.errorCode==0 && result.data.rowCount>0){

            this.dataSource=result.data.dataSource;
           }

    this.setBackUrl("/folder");

    this.contentHeight = document.documentElement.clientHeight;
    this.contentWidth = document.documentElement.clientWidth;
    // this.$nextTick(() => {
    //   this.getShowBtn();
    // });
    const that = this;
    window.onresize = function temp() {
      that.contentHeight = document.documentElement.clientHeight;
      that.contentWidth = document.documentElement.clientWidth;
      // that.$nextTick(() => {
      //   that.getShowBtn();
      // });
    };
    this.activeMenu = this.$route.path;
    // this.getFolder();

    let getid = setInterval(() => {
      let getBox = document.getElementById("leftIndexMenu");
      if (getBox) {
        clearInterval(getid);
        this.getHotLineHeight(this.contentHeight, "leftIndexMenu", -83);
      }
    }, 300);

    var folderResult = await this.AFolder();
    await this.setfolder(folderResult.data);
  }
};
</script>

<style lang="less" scoped>
@import "../assets/style/color";
@import "../assets/style/config";
@import "../assets/style/mixin";

.el-main {
  background-color: @body-background-color;
  color: #333;
  text-align: center;
  box-shadow: inset 0px 8px 7px 0px rgba(16, 88, 246, 0.2);
  display: inline-block;
  padding-bottom: 0;
}
.menu {
  background-color: #fff;
  border-right: 1px solid rgb(210, 201, 201);
  margin-top: -3px;
  // height: 100% !important;
  // //position: fixed !important;
  // left: 0 !important;
  // display: flow-root !important;
  // position: absolute !important;
}
.ml5 {
  margin-left: 5px;
  font-size: 14px;
}
//菜单
.home .menu .menu-item {
  line-height: 41px;
  margin-top: 10px;
}
.home .menu .menu-item .menu-item-content {
  margin: 10px 0;
}
.home .menu .menu-item .menu-item-content span:first-child {
  margin-left: 30px;
}
.home .menu .menu-item .menu-item-content:hover {
  background-color: #e6eef9;
  color: @theme-color;
  cursor: pointer;
}

.home .menu .menuItemActive {
  background-color: #e6eef9;
  color: @theme-color;
  cursor: pointer;
}
// 文档菜单
.home .menu .menu-item-document {
  height: 41px;
  line-height: 41px;
}
.home .menu .menu-item-document .menu-item-content span:first-child {
  margin-left: 30px;
}
.home .menu .menu-item-document .menu-item-content:hover {
  background-color: #e6eef9;
  color: @theme-color;
  cursor: pointer;
}
.home .menu .menu-item-document .menu-item-content span.toggle-icon {
  margin-left: 14px;
}
.menu-ul {
  background-color: @theme-background-color;
}

.home .menu .menu-item-document .menu-item-content .folderdelete {
  display: none;
}
.home .menu .menu-item-document .menu-item-content:hover .folderdelete {
  display: inline;
}
.home .menu .menu-item-document .menu-item-content .isdelete {
  display: inline;
  color: red;
}
.document-dialog {
  .login-tip {
    text-align: center;
    margin: 20px 0;
  }
  .dialog-tologin {
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 8px 20px;
  }
  .dialog-document .dialog-title {
    font-size: 14px;
  }
}
</style>

<style lang="less">
.document-dialog .el-dialog__header {
  padding: 15px;
  border-bottom: 1px solid #f4f4f4;
}
.document-dialog .el-dialog__body {
  padding: 5px;
}
//新增文集
.document-new-dialog {
  .el-dialog {
    height: 200px;
  }
  .el-dialog__header {
    padding: 0;
    display: flex;
    align-items: center;
    height: 46px;
    border-bottom: 1px solid #f4f4f4;
    .dialog-title {
      height: 20px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
      margin-left: 14px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  .el-dialog__body {
    height: 100px;
    padding: 28px;
  }
  .documentName .el-input__inner {
    border-radius: 20px;
    height: 40px;
  }
  //确认按钮
  .dialog-newDocument {
    width: 100px;
    height: 37px;
    background: rgba(16, 88, 246, 1);
    border-radius: 19px;
    color: rgba(255, 255, 255, 1);
    border: 0;
  }
  // 取消按钮
  .dialog-newDocument-cancle {
    width: 100px;
    height: 37px;
    background: rgba(226, 226, 226, 1);
    border-radius: 19px;
    color: rgba(102, 102, 102, 1);
    border: 0;
  }
  .el-dialog__footer {
    padding: 0px;
  }
}

//删除文集弹窗
.dialog-delete-folder {
  .el-dialog {
    height: 200px;
  }
  .el-dialog__header {
    padding: 0;
    display: flex;
    align-items: center;
    height: 46px;
    border-bottom: 1px solid #f4f4f4;
    .dialog-title {
      width: 64px;
      height: 16px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
      margin-left: 14px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  .el-dialog__body {
    text-align: center;
    padding: 5px;

    .confirm-delete-title {
      height: 24px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: rgba(255, 77, 77, 1);
      line-height: 20px;
      margin-top: 23px;
    }
    .confirm-delete-info {
      height: 14px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: rgba(85, 85, 85, 1);
      line-height: 20px;
      margin-top: 13px;
    }
  }

  .dialog-footer {
    padding: 12px;
    .dialog-delete {
      width: 100px;
      height: 37px;
      background: rgba(16, 88, 246, 1);
      border-radius: 19px;
      color: rgba(255, 255, 255, 1);
      border: 0;
    }
  }
}
.links {
    padding-top: 10px;
    color: black !important;
    font-size: 12px;
    text-align: center;
    line-height: 24px;
}
.links .link-item{
     color:black !important;
    display: inline-block;
    margin-right: 13px;
    cursor: pointer;
}
</style>
